import api from '@/api/hrDashboard'

const state = {
  contentHideStatus: { jobs: true, applications: true, channels: true, interviews: true, talentPool: true },
  tabStatus: {
    jobs: true,
    jobAging: true,
    channels: true,
    interviews: true,
    applications: true
  },
  applicationSelected: { all: '7', new: '7', screening: '7', interviewing: '7', onboarding: '7' },
  jobsTabStatus: 'my',
  applicationsTabStatus: 'my',
  channelsTabStatus: 'applications',
  interviewsTabStatus: 'my'
}

const actions = {
  getJobCountInfo (context, params) {
    return api.getJobCountInfo(params)
  },
  getApplicationCountInfo (context, params) {
    return api.getApplicationCountInfo(params)
  },
  getApplicationDataInfo (context, params) {
    return api.getApplicationDataInfo(params)
  },
  getChannelCountInfo (context, params) {
    return api.getChannelCountInfo(params)
  },
  getInterviewInfo (context, params) {
    return api.getInterviewInfo(params)
  },
  getPersonalizedInfo (context, params) {
    return api.getPersonalizedInfo(params)
  },
  savePersonalizedInfo (context, params) {
    return api.savePersonalizedInfo(params)
  },
  changeContentHideStatus ({ commit }, name) {
    commit('CHANGE_CONTENT_HIDE_STATUS', name)
  },
  changeTabStatus ({ commit }, name) {
    commit('TAB_STATUS', name)
  },
  changeApplicationSelected ({ commit }, params) {
    commit('APPLICATION_SELECTED', params)
  },
  changeJobTabStatus ({ commit }, value) {
    commit('JOBS_TAB_STATUS', value)
  },
  changeApplicationsTabStatus ({ commit }, value) {
    commit('APPLICATIONS_TAB_STATUS', value)
  },
  changeChannelsTabStatus ({ commit }, value) {
    commit('CHANNELS_TAB_STATUS', value)
  },
  changeInterviewsTabStatus ({ commit }, value) {
    commit('INTERVIEWS_TAB_STATUS', value)
  }
}

const mutations = {
  CHANGE_CONTENT_HIDE_STATUS (state, name) {
    state.contentHideStatus[name] = !state.contentHideStatus[name]
  },
  TAB_STATUS (state, name) {
    state.tabStatus[name] = !state.tabStatus[name]
  },
  APPLICATION_SELECTED (state, params) {
    state.applicationSelected[params.name] = params.value
  },
  JOBS_TAB_STATUS (state, value) {
    state.jobsTabStatus = value
  },
  APPLICATIONS_TAB_STATUS (state, value) {
    state.applicationsTabStatus = value
  },
  CHANNELS_TAB_STATUS (state, value) {
    state.channelsTabStatus = value
  },
  INTERVIEWS_TAB_STATUS (state, value) {
    state.interviewsTabStatus = value
  }

}

const getters = {
  contentHideStatus (state) {
    return state.contentHideStatus
  },
  jobsTabStatus (state) {
    return state.jobsTabStatus
  },
  applicationsTabStatus (state) {
    return state.applicationsTabStatus
  },
  channelsTabStatus (state) {
    return state.channelsTabStatus
  },
  interviewsTabStatus (state) {
    return state.interviewsTabStatus
  },
  tabStatus (state) {
    return state.tabStatus
  },
  applicationSelected (state) {
    return state.applicationSelected
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
